module.exports = __webpack_public_path__ + "static/media/flower.557b0a4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Services/flower.svg
// module id = 166
// module chunks = 0